module.exports = __webpack_public_path__ + "media/images/childcare/main_image1@3x-7565a521a37bef322ec93c426d2fa0c6.jpg";